import { showAlert } from 'utils/toastBridge';
import { buildPrintHtml, openPrintWindow } from './printHtml';

/** 1차: 인쇄·PDF만. HWP는 동일 레이아웃으로 이후. */
export const PRINT_FORMATS = [
  { id: 'print', label: '인쇄', enabled: true, title: '브라우저 인쇄 미리보기' },
  { id: 'pdf', label: 'PDF', enabled: true, title: '인쇄 대화상자에서 PDF로 저장' },
  { id: 'hwp', label: 'HWP', enabled: false, title: '1차 이후 · 미리보기·인쇄/PDF와 동일 레이아웃' },
  { id: 'hwpx', label: 'HWPX', enabled: false, title: '이후 지원' },
  { id: 'xls', label: 'XLS', enabled: false, title: '이후 지원' },
  { id: 'xlsx', label: 'XLSX', enabled: false, title: '이후 지원 · 엑셀 버튼 사용' },
  { id: 'doc', label: 'DOC', enabled: false, title: '이후 지원' },
  { id: 'docx', label: 'DOCX', enabled: false, title: '이후 지원' },
];

/**
 * @returns {{ ok: boolean, reason?: string }}
 */
export function renderPrintFormat(formatId, model, layout, _fileName, ctx) {
  const id = String(formatId || '');
  const html = buildPrintHtml(model, layout, ctx);

  if (id === 'print') {
    return openPrintWindow(html);
  }
  if (id === 'pdf') {
    const result = openPrintWindow(html);
    if (result.ok) {
      showAlert('인쇄 대화상자에서 대상(프린터)을 「PDF로 저장」으로 선택하세요.', 'info');
    }
    return result;
  }
  return { ok: false, reason: '1차에서는 인쇄·PDF만 지원합니다.' };
}
